

import { Component, ViewChild, ElementRef ,Output, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import html2canvas from 'html2canvas';
import { saveAs } from 'file-saver'; 
import { clinicalAssesmentDetail } from '../../../@core/interfaces/masters/clinicalassessment';


interface Dialog {
  text: string;
  top: number;
  left: number;
  width: number;
  height: number;
  editing?: boolean;
  hovered?: boolean;
  color?: string;
}
interface DialogData {
  imageUrl: string;
}

@Component({
  selector: 'ngx-image-annotation',
  templateUrl: './image-annotation.component.html',
  styleUrls: ['./image-annotation.component.scss']
})
export class ImageAnnotationComponent implements OnInit {

  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('image') imageElement!: ElementRef<HTMLImageElement>;
  @ViewChild('imageWrapper') imageWrapper!: ElementRef;
  // any used purposefully
  @ViewChild('fileInput') fileInput: any;
  @Output() imageUpdated = new EventEmitter<string>();
  @Output() closePopupEvent = new EventEmitter<void>();
  @Output() modifiedImageUrl = new EventEmitter<{ url: string, imageFieldDetail:clinicalAssesmentDetail }>();

  ctx!: CanvasRenderingContext2D;
  backgroundUrl: string | null = null;
  private shapes: { type: 'rectangle' | 'circle' | 'freehand' | 'line' | 'dot', points: { x: number, y: number }[], color: string, radius?: number }[] = [];
  private isDrawing: boolean = false;
  private currentShape: 'rectangle' | 'circle' | 'freehand' | 'line'|'dot' = 'rectangle';
  public isDrawingEnabled: boolean = false;
  private lastSelectedShape!: 'rectangle' | 'circle' | 'freehand' | 'line' | 'dot' | null;
  private lastShapeEnabled: boolean = false;
  selectedColor: string = "#170d0d";
  defaultColor: string = '#2C414C';
  currentColor: string = '#2C414C';
  isViewModeActive: boolean = false;
  viewButtonActive: boolean = false;
  mouseX = 0;
  mouseY = 0;
  scaleFactor = 1;
  offsetX: number = 0;
  offsetY: number = 0;
  lines: { startX: number, startY: number, endX: number, endY: number, unit: string, color: string }[] = [];
  startPoint: { x: number, y: number } | null = null;
  unit: string = 'cm'; 
  lineLength: number = 0;
  isAutomaticLineDrawing: boolean = false; 
  isManualLineDrawing: boolean = false;
  lineDirection: string = 'horizontal';
  deleteIconClicked: boolean = false;
  lastClickedShapeIndex: number | null = null;
  lastClickedShapeType: 'shape' | 'line' | 'dialog' | null = null;
  private isResize: boolean = false;
  public resizeButtonActive: boolean = false;
  private selectedShapeIndex: number | null = null;
  private isDragAndDropEnabled: boolean = false;
  private isDragging: boolean = false;
  private dragStartX: number = 0;
  private dragStartY: number = 0;
  selectedLineIndex: number | null = null;
  isDraggingLine = false;
  private history: any[] = [];
  private historyIndex: number = -1;
  private redoHistory: any[] = [];
  dialogs: Dialog[] = [];
  private resizeDialog: Dialog | null = null;
  private startX = 0;
  private startY = 0;
  private startWidth = 0;
  private startHeight = 0;
  private draggingElement: HTMLElement | null = null;
  private svgClicked: boolean = false; // Flag to indicate whether SVG is clicked
  private buttonClicked: boolean = false;
  private rightClickHandler: EventListener | null = null;
  image:string='set';

  isHovered: boolean[] = [];
  isSquareHovered: boolean[] = [];
  isDialogueHovered: boolean[] = [];
  isDialogueBoxHovered: boolean[] = [];
  isEditing: boolean[] = [];
  showPer:boolean=false
  loadPer:number=10
  selectedButton:string=''
  selectedButton2:string=''


  constructor(
    private elementRef: ElementRef,
    private dialogRef: MatDialogRef<ImageAnnotationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  ngOnInit() {
    this.backgroundUrl = this.data.imageUrl ?? ''; 
    window.localStorage.setItem('image', this.backgroundUrl !== null ? this.backgroundUrl : ''); 
}




  closePopup() {
    this.showPer=false
    this.loadPer=10
    this.dialogRef.close();
  }



  takeScreenshotAndSave() {
    this.showPer = true;
    this.loadPer = 30;
  
    const targetElement = this.imageWrapper?.nativeElement;
    if (!targetElement) {
      console.error('Element not found');
      this.showPer = false;
      this.loadPer = 10;
      return;
    }
  
    this.loadPer = 50;
    html2canvas(targetElement, { useCORS: true }).then(canvas => {
      canvas.toBlob(blob => {
        if (blob) {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          this.loadPer = 80;
          reader.onloadend = () => {
            const base64Data = reader.result as string;
            this.modifiedImageUrl.emit({
              url: base64Data,
              imageFieldDetail: this.data.imageFieldDetail
            });
            this.loadPer = 100;
            this.showPer = false;
            this.loadPer = 10;
            this.dialogRef.close(base64Data);
          };
        } else {
          this.showPer = false;
          this.loadPer = 10;
          console.error('Error creating blob');
        }
      });
    }).catch(error => {
      this.showPer = false;
      this.loadPer = 10;
      console.error('Error capturing screenshot:', error);
    });
  }
  

  
  ngAfterViewInit(): void {
    const canvasElement = this.canvas.nativeElement;
    const context = canvasElement.getContext('2d');
    if (context) {
      this.ctx = context;
      this.setCanvasSize();
      this.setupCanvas();
    } else {
      console.error('Failed to get 2D context for canvas element.');
    }
    this.saveState();
  }
  selectColorFromSVG(event: MouseEvent): void {
    const button = event.currentTarget as HTMLButtonElement;
    this.currentColor = this.defaultColor;
    const svg = button.querySelector('svg');
    if (svg) {
        const circle = svg.querySelector('circle');
        if (circle) {
            const color = circle.getAttribute('fill');
            if (color) {
                this.selectedColor = color;
                
                if (this.lastClickedShapeType === 'dialog' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
                    this.dialogs[this.lastClickedShapeIndex].color = color;
                } else if (this.lastClickedShapeType === 'shape' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
                    this.shapes[this.lastClickedShapeIndex].color = color;
                    this.drawShapes();
                    this.drawLines();
                } else if (this.lastClickedShapeType === 'line' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
                    this.lines[this.lastClickedShapeIndex].color = color;
                    this.drawShapes();
                    this.drawLines();
                }

                const editingDialog = this.dialogs.find(d => d.editing);
                if (editingDialog) {
                    editingDialog.color = color;
                }
            }
        }
    }
}

selectShape(shape: 'rectangle' | 'circle' | 'freehand' | 'line' | 'dot'): void {
    this.selectedButton2 = '';
    this.isDragAndDropEnabled = false;
    this.resizeButtonActive = false;

    this.selectedButton=shape  
    if (shape === 'dot') {    
          this.isDrawingEnabled = !this.isDrawingEnabled;
          this.currentShape = shape;
          this.selectedButton = this.isDrawingEnabled ? 'dot' : ''
          if (!this.isDrawingEnabled) {
              this.isDrawingEnabled = this.currentShape !== 'dot';
          }
    } else {
      if (this.lastSelectedShape === shape) {
          this.isDrawingEnabled = !this.isDrawingEnabled;
          this.lastShapeEnabled = this.isDrawingEnabled;
          this.selectedButton=''
      } else {
          this.lastSelectedShape = shape;
          this.lastShapeEnabled = this.isDrawingEnabled;
          this.isDrawingEnabled = true;
          this.currentShape = shape;
      }
    }
}
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  const reader = new FileReader();
  reader.onload = (e: any) => {
    this.backgroundUrl = e.target.result;
  };
  reader.readAsDataURL(file);
}

chooseFile() {
  document.getElementById('fileInput')?.click();
}
createDotShape(event: MouseEvent): void {
  if (this.currentShape !== 'dot' || !this.isDrawingEnabled || !this.ctx || this.isManualLineDrawing) return; 
  const rect = this.canvas.nativeElement.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;

  const dotRadius = 6;
  const dot: { type: "dot"; points: { x: number; y: number; }[]; color: string; radius: number; } = {
      type: 'dot',
      points: [{ x, y }],
      color: this.selectedColor,
      radius: dotRadius
  };

  this.shapes.push(dot);

  this.drawDot(x, y);

  this.lastClickedShapeIndex = this.shapes.length - 1;
  this.lastClickedShapeType = 'shape';

  this.drawShapes();
  this.drawLines();
}

  onCanvasClick(event: MouseEvent): void {
    const rect = this.canvas.nativeElement.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    // First check if user clicked on an existing shape
    for (let i = this.shapes.length - 1; i >= 0; i--) {
      const shape = this.shapes[i];
      if (this.isPointInsideShape(mouseX, mouseY, shape)) {
        this.lastClickedShapeIndex = i;
        this.lastClickedShapeType = 'shape';
        this.drawShapes();
        this.drawLines();
        return;
      }
    }

    // Next check if user clicked on an existing line
    for (let i = this.lines.length - 1; i >= 0; i--) {
      const line = this.lines[i];
      if (this.isPointInsideLine(mouseX, mouseY, line)) {
        this.lastClickedShapeIndex = i;
        this.lastClickedShapeType = 'line';
        this.drawShapes();
        this.drawLines();
        return;
      }
    }

    // If they clicked on empty space, perform the tool's action
    if (this.selectedButton === 'Text') {
      const defaultText = '';
      const dialogWidth = 120;
      const dialogHeight = 40;

      const newDialog: Dialog = {
        text: defaultText,
        left: mouseX,
        top: mouseY,
        width: dialogWidth,
        height: dialogHeight,
        editing: true,
        color: this.selectedColor
      };
      this.saveState();
      this.dialogs.push(newDialog);
      this.lastClickedShapeType = 'dialog';
      this.lastClickedShapeIndex = this.dialogs.length - 1;

      setTimeout(() => {
        const dialogIndex = this.dialogs.length - 1;
        const dialogElements = this.elementRef.nativeElement.querySelectorAll('.dialogue-box');
        if (dialogElements[dialogIndex]) {
          const input = dialogElements[dialogIndex].querySelector('.inputBox') as HTMLInputElement;
          if (input) {
            input.focus();
          }
        }
      }, 50);
      return;
    }

    if (this.isAutomaticLineDrawing) {
      const rect = this.canvas.nativeElement.getBoundingClientRect();
      const startX = event.clientX - rect.left;
      const startY = event.clientY - rect.top;
      let endX = startX;
      let endY = startY;
    
      if (this.lineDirection === 'horizontal') {
        endX += this.lineLength; 
      } else if (this.lineDirection === 'vertical') {
        endY += this.lineLength; 
      }
      this.drawDot(startX, startY);
      this.drawDot(endX, endY);   
    
      this.draw(startX, startY, endX, endY, this.selectedColor); 
    
      const length = this.calculateLength(startX, startY, endX, endY);
      this.drawLength(startX, startY, endX, endY, length, this.unit);
    
      this.lines.push({ startX: startX, startY: startY, endX: endX, endY: endY, unit: this.unit, color: this.selectedColor });
      return;
    }
    else if (this.currentShape === 'dot' && !this.isManualLineDrawing) {
      this.createDotShape(event);
      return;
    }

    // Clicked empty space with no active creation tool: clear selection
    this.lastClickedShapeIndex = null;
    this.lastClickedShapeType = null;
    this.drawShapes();
    this.drawLines();
  }
  isPointInsideShape(x: number, y: number, shape: any): boolean {
    if (shape.type === 'rectangle') {
        const startPoint = shape.points[0];
        const endPoint = shape.points[shape.points.length - 1];
        const minX = Math.min(startPoint.x, endPoint.x);
        const maxX = Math.max(startPoint.x, endPoint.x);
        const minY = Math.min(startPoint.y, endPoint.y);
        const maxY = Math.max(startPoint.y, endPoint.y);
        return x >= minX && x <= maxX && y >= minY && y <= maxY;
    } else if (shape.type === 'circle' && shape.points.length >= 2) {
        const startPoint = shape.points[0];
        const endPoint = shape.points[shape.points.length - 1];
        const radius = Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2)) / 2;
        const centerX = startPoint.x + (endPoint.x - startPoint.x) / 2;
        const centerY = startPoint.y + (endPoint.y - startPoint.y) / 2;
        return Math.sqrt(Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)) <= radius;
    } else if (shape.type === 'dot') {
        const dotRadius = 6;
        const distance = Math.sqrt((x - shape.points[0].x) ** 2 + (y - shape.points[0].y) ** 2);
        return distance <= dotRadius;
    } else if (shape.type === 'freehand' || shape.type === 'line') {
        for (let i = 0; i < shape.points.length - 1; i++) {
            const startX = shape.points[i].x;
            const startY = shape.points[i].y;
            const endX = shape.points[i + 1].x;
            const endY = shape.points[i + 1].y;
            const distance = this.distanceFromPointToLine(x, y, startX, startY, endX, endY);
            if (distance <= 5) {
                return true;
            }
        }
        return false;
    }
    return false;
}


isPointInsideLine(mouseX: number, mouseY: number, line: any): boolean {
  const tolerance = 5; 
  const distance = this.distanceFromPointToLine(mouseX, mouseY, line.startX, line.startY, line.endX, line.endY);
  return distance <= tolerance;
}

  
  distanceFromPointToLine(x: number, y: number, x1: number, y1: number, x2: number, y2: number): number {
    const A = x - x1;
    const B = y - y1;
    const C = x2 - x1;
    const D = y2 - y1;
  
    const dot = A * C + B * D;
    const len_sq = C * C + D * D;
    const param = dot / len_sq;
  
    let xx, yy;
  
    if (param < 0) {
      xx = x1;
      yy = y1;
    } else if (param > 1) {
      xx = x2;
      yy = y2;
    } else {
      xx = x1 + param * C;
      yy = y1 + param * D;
    }
  
    const dx = x - xx;
    const dy = y - yy;
    return Math.sqrt(dx * dx + dy * dy);
  }
  deleteShape(): void {
    if (this.lastClickedShapeType === 'shape' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
        this.shapes.splice(this.lastClickedShapeIndex, 1);
    } else if (this.lastClickedShapeType === 'line' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
        this.lines.splice(this.lastClickedShapeIndex, 1);
    } else if (this.lastClickedShapeType === 'dialog' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
        this.deleteDialog(this.lastClickedShapeIndex);
    }

    this.lastClickedShapeIndex = null;
    this.lastClickedShapeType = null;

    this.drawShapes();
    this.drawLines();
}

  setupCanvas() {
    const canvas = this.canvas.nativeElement;
    canvas.width =750;
    canvas.height = 400;
    canvas.style.width = 750 + 'px';
    canvas.style.height = 400 + 'px';
  }

  setCanvasSize(): void {
    const canvasElement = this.canvas.nativeElement;
    const parentElement = canvasElement.parentElement;
    if (parentElement) {
      canvasElement.width = parentElement.clientWidth;
      canvasElement.height = parentElement.clientHeight;
    }
  }

  onMouseDown(event: MouseEvent): void {
    this.saveState();
    const rect = this.canvas.nativeElement.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;
    if (this.isDragAndDropEnabled) {

      for (let i = this.shapes.length - 1; i >= 0; i--) {
          const shape = this.shapes[i];
          if (this.isPointInsideShape(mouseX, mouseY, shape)) {
              this.selectedShapeIndex = i;
              this.dragStartX = mouseX;
              this.dragStartY = mouseY;
              this.isDragging = true;
              event.preventDefault();
              return;
          }
      }

      for (let i = this.lines.length - 1; i >= 0; i--) {
          const line = this.lines[i];
          if (this.isPointInsideLine(mouseX, mouseY, line)) {
              this.selectedLineIndex = i;
              this.dragStartX = mouseX;
              this.dragStartY = mouseY;
              this.isDraggingLine = true;
              event.preventDefault();
              return;
          }
      }
  }else if (this.resizeButtonActive) {
        let foundShapeOrLine = false;
        for (let i = this.shapes.length - 1; i >= 0; i--) {
            const shape = this.shapes[i];
            if (this.isPointInsideShape(mouseX, mouseY, shape)) {
                this.selectedShapeIndex = i;
                this.offsetX = mouseX - shape.points[0].x;
                this.offsetY = mouseY - shape.points[0].y;
                this.isResize = true;
                foundShapeOrLine = true;
                break;
            }
        }

        if (!foundShapeOrLine) {
            for (let i = 0; i < this.lines.length; i++) {
                const line = this.lines[i];
                if (this.isPointInsideLine(mouseX, mouseY, line)) {
                    this.selectedShapeIndex = i + this.shapes.length; 
                    this.offsetX = mouseX - line.startX;
                    this.offsetY = mouseY - line.startY;
                    this.isResize = true;
                    foundShapeOrLine = true;
                    break;
                }
            }
        }
        if (!foundShapeOrLine) {
            this.selectedShapeIndex = null;
        }
        return;
    }
    else if (this.isManualLineDrawing) {
        this.isDrawing = true;
        const rect = this.canvas.nativeElement.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const offsetY = event.clientY - rect.top;
        this.startPoint = { x: offsetX, y: offsetY };
        this.clearCanvas();
        this.drawShapes();
        this.drawLines();
    } else if (this.isViewModeActive) {
        this.offsetX = this.imageElement.nativeElement.offsetLeft - event.clientX;
        this.offsetY = this.imageElement.nativeElement.offsetTop - event.clientY;
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
        return;
    } else if (!this.isDrawingEnabled) return;

    if (this.currentShape === 'dot') return;

    this.isDrawing = true;
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    this.ctx!.strokeStyle = this.selectedColor;

    this.shapes.push({ type: this.currentShape, points: [{ x, y }], color: this.selectedColor });

    this.clearCanvas();
    this.drawShapes();
    this.drawLines();
}

onMouseMove(event: MouseEvent): void {
  if (this.isDragging || this.isDraggingLine) {
    event.preventDefault();
    const rect = this.canvas.nativeElement.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    if (this.selectedShapeIndex !== null && this.isDragging) {
        const shape = this.shapes[this.selectedShapeIndex];
        const deltaX = mouseX - this.dragStartX;
        const deltaY = mouseY - this.dragStartY;
        for (const point of shape.points) {
            point.x += deltaX;
            point.y += deltaY;
        }
        this.dragStartX = mouseX;
        this.dragStartY = mouseY;
        this.clearCanvas();
        this.drawShapes();
        this.drawLines();
        event.preventDefault();
    }

    if (this.selectedLineIndex !== null && this.isDraggingLine) {
        const line = this.lines[this.selectedLineIndex];
        const deltaX = mouseX - this.dragStartX;
        const deltaY = mouseY - this.dragStartY;

        line.startX += deltaX;
        line.startY += deltaY;
        line.endX += deltaX;
        line.endY += deltaY;

        this.dragStartX = mouseX;
        this.dragStartY = mouseY;

        this.clearCanvas();
        this.drawShapes();
        this.drawLines();
        event.preventDefault();
    }
    return;
  }else if (this.isResize && this.selectedShapeIndex !== null) {
    const rect = this.canvas.nativeElement.getBoundingClientRect();
    const mouseX = event.clientX - rect.left;
    const mouseY = event.clientY - rect.top;

    if (this.selectedShapeIndex < this.shapes.length) {
        const shape = this.shapes[this.selectedShapeIndex];
        if (shape.type === 'dot') {
            const originalX = shape.points[0].x;
            const originalY = shape.points[0].y;
            const dx = mouseX - originalX;
            const dy = mouseY - originalY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            shape.radius = distance;
            this.clearCanvas();
            this.drawShapes();
            this.drawLines();
            return;
        } else {
            shape.points[0].x = mouseX - this.offsetX;
            shape.points[0].y = mouseY - this.offsetY;
        }
    } else {
        const line = this.lines[this.selectedShapeIndex - this.shapes.length];
        const deltaX = mouseX - (line.startX + this.offsetX);
        const deltaY = mouseY - (line.startY + this.offsetY);
        line.endX = line.startX + deltaX;
        line.endY = line.startY + deltaY;
    }
    this.clearCanvas();
    this.drawShapes();
    this.drawLines();
    return;
  }else if (this.isViewModeActive) {
        if (event.buttons === 1) {
            const newX = event.clientX + this.offsetX;
            const newY = event.clientY + this.offsetY;
            this.imageElement.nativeElement.style.left = newX + 'px';
            this.imageElement.nativeElement.style.top = newY + 'px';
            return;
        }
        return;
    } else if (this.isManualLineDrawing && this.isDrawing) {
        const rect = this.canvas?.nativeElement.getBoundingClientRect();
        const offsetX = event.clientX - (rect?.left || 0);
        const offsetY = event.clientY - (rect?.top || 0);
        const endX = offsetX;
        const endY = offsetY;
        this.clearCanvas();
        this.drawShapes();
        this.drawLines();

        if (this.startPoint) {
            this.draw(this.startPoint.x, this.startPoint.y, endX, endY, this.selectedColor);
            this.drawDot(this.startPoint.x, this.startPoint.y);
        }
        return;
    } else if (!this.isDrawing) return;

    this.clearCanvas();
    this.drawShapes();
    this.drawLines();

    const rect = this.canvas.nativeElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const lastIndex = this.shapes.length - 1;

    if (this.currentShape === 'line') {
        this.shapes[lastIndex].points[1] = { x, y };
    } else {
        this.shapes[lastIndex].points.push({ x, y });
    }

    this.drawShapes();
    this.drawLines();
}

onMouseUp(event: MouseEvent): void {
  if (this.isDragging || this.isDraggingLine) {
    this.isDragging = false;
    this.isDraggingLine = false;
    this.selectedShapeIndex = null;
    this.selectedLineIndex = null;
    return;
  }else if (this.isResize) {
    this.isResize = false;
    this.selectedShapeIndex = null;
    return;
  }
    if (this.viewButtonActive || this.isViewModeActive) return;
    if (this.isManualLineDrawing && this.isDrawing) {
        this.isDrawing = false;
        const rect = this.canvas?.nativeElement.getBoundingClientRect();
        const offsetX = event.clientX - (rect?.left || 0);
        const offsetY = event.clientY - (rect?.top || 0);
        const endX = offsetX;
        const endY = offsetY;
        if (this.startPoint) {
            this.lines.push({ startX: this.startPoint.x, startY: this.startPoint.y, endX: endX, endY: endY, unit: this.unit, color: this.selectedColor });
            this.startPoint = null;
            this.drawLines();
            this.drawDot(endX, endY);
        }
        this.drawShapes();
    } else if (!this.isDrawing) return;
    this.isDrawing = false;
    if (this.currentShape === 'line' && this.shapes[this.shapes.length - 1].points.length === 2) {
        this.drawShapes();
        return;
    }
    this.isDrawingEnabled = true;
}
toggleResize(): void {
  this.resizeButtonActive = !this.resizeButtonActive;
  this.isDragAndDropEnabled = false;
  this.selectedButton2 = this.resizeButtonActive ? 'Resize' : '';

  if (this.resizeButtonActive) {
    this.selectedButton = '';
    this.isDrawingEnabled = false;
    this.isManualLineDrawing = false;
    this.isAutomaticLineDrawing = false;
  }
}
toggleDragAndDrop(): void {
  this.isDragAndDropEnabled = !this.isDragAndDropEnabled;
  this.resizeButtonActive = false;
  this.selectedButton2 = this.isDragAndDropEnabled ? 'Drag & Drop' : '';

  if (this.isDragAndDropEnabled) {
    this.selectedButton = '';
    this.isDrawingEnabled = false;
    this.isManualLineDrawing = false;
    this.isAutomaticLineDrawing = false;
  }
}
  
private drawShapes(): void {
  if (!this.ctx) {
    console.error('Canvas context is not available.');
    return;
  }

  this.drawLines();
  this.clearCanvas();

  for (const shape of this.shapes) {
    this.ctx.strokeStyle = shape.color;
    let lineWidth = 2;

    this.ctx.lineWidth = lineWidth; // Set the line width

    const isSelected = this.lastClickedShapeType === 'shape' && this.lastClickedShapeIndex !== null && this.shapes[this.lastClickedShapeIndex] === shape;

    if (shape.type === 'rectangle' && shape.points.length >= 2) {
      const startPoint = shape.points[0];
      const endPoint = shape.points[shape.points.length - 1];
      const width = endPoint.x - startPoint.x;
      const height = endPoint.y - startPoint.y;
      this.ctx.strokeRect(startPoint.x, startPoint.y, width, height);

      if (isSelected) {
        this.ctx.save();
        this.ctx.strokeStyle = '#007bff';
        this.ctx.lineWidth = 1.5;
        this.ctx.setLineDash([4, 4]);
        this.ctx.strokeRect(startPoint.x - 4, startPoint.y - 4, width + 8, height + 8);
        this.ctx.restore();
      }
    } else if (shape.type === 'circle' && shape.points.length >= 2) {
      const startPoint = shape.points[0];
      const endPoint = shape.points[shape.points.length - 1];
      const width = endPoint.x - startPoint.x;
      const height = endPoint.y - startPoint.y;
      const centerX = startPoint.x + width / 2;
      const centerY = startPoint.y + height / 2;
      const radius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
      this.ctx.beginPath();
      this.ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
      this.ctx.stroke();

      if (isSelected) {
        this.ctx.save();
        this.ctx.strokeStyle = '#007bff';
        this.ctx.lineWidth = 1.5;
        this.ctx.setLineDash([4, 4]);
        const boundRadius = radius + 4;
        this.ctx.strokeRect(centerX - boundRadius, centerY - boundRadius, boundRadius * 2, boundRadius * 2);
        this.ctx.restore();
      }
    } else if (shape.type === 'freehand' && shape.points.length > 1) {
      this.ctx.beginPath();
      const startPoint = shape.points[0];
      this.ctx.moveTo(startPoint.x, startPoint.y);
      for (let i = 1; i < shape.points.length; i++) {
        const point = shape.points[i];
        this.ctx.lineTo(point.x, point.y);
      }
      this.ctx.stroke();

      if (isSelected) {
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        for (const p of shape.points) {
          if (p.x < minX) minX = p.x;
          if (p.x > maxX) maxX = p.x;
          if (p.y < minY) minY = p.y;
          if (p.y > maxY) maxY = p.y;
        }
        this.ctx.save();
        this.ctx.strokeStyle = '#007bff';
        this.ctx.lineWidth = 1.5;
        this.ctx.setLineDash([4, 4]);
        this.ctx.strokeRect(minX - 4, minY - 4, (maxX - minX) + 8, (maxY - minY) + 8);
        this.ctx.restore();
      }
    } else if (shape.type === 'line' && shape.points.length >= 2) {
      const startPoint = shape.points[0];
      this.ctx.beginPath();
      this.ctx.moveTo(startPoint.x, startPoint.y);
      for (let i = 1; i < shape.points.length; i++) {
        const point = shape.points[i];
        this.ctx.lineTo(point.x, point.y);
      }
      this.ctx.stroke();

      if (isSelected) {
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        for (const p of shape.points) {
          if (p.x < minX) minX = p.x;
          if (p.x > maxX) maxX = p.x;
          if (p.y < minY) minY = p.y;
          if (p.y > maxY) maxY = p.y;
        }
        this.ctx.save();
        this.ctx.strokeStyle = '#007bff';
        this.ctx.lineWidth = 1.5;
        this.ctx.setLineDash([4, 4]);
        this.ctx.strokeRect(minX - 4, minY - 4, (maxX - minX) + 8, (maxY - minY) + 8);
        this.ctx.restore();
      }
    } else if (shape.type === 'dot') {
      for (const point of shape.points) {
        const dotRadius = shape.radius || 6; //dot radius
        this.ctx.beginPath();
        this.ctx.arc(point.x, point.y, dotRadius, 0, 6 * Math.PI);
        this.ctx.fillStyle = shape.color; 
        this.ctx.fill();

        if (isSelected) {
          this.ctx.save();
          this.ctx.strokeStyle = '#007bff';
          this.ctx.lineWidth = 1.5;
          this.ctx.setLineDash([4, 4]);
          this.ctx.strokeRect(point.x - dotRadius - 4, point.y - dotRadius - 4, (dotRadius + 4) * 2, (dotRadius + 4) * 2);
          this.ctx.restore();
        }
      }
    }
  }
}

  
  private clearCanvas(): void {
    if (!this.ctx) return;
    this.ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
  }

  onChangeShape(event: Event): void {
    const target = event.target as HTMLSelectElement | null;
    if (target && target.value) {
      const newShape = target.value as 'rectangle' | 'circle' | 'freehand' | 'line';
      this.currentShape = newShape;
    }
  } 
  zoomIn() {
    this.scaleFactor += 0.1;
    this.applyTransform();
  }

  zoomOut() {
    if (this.scaleFactor > 1) {
      this.scaleFactor -= 0.1;
      this.applyTransform();
    }
  }

  applyTransform() {
    const imageElement = this.imageElement.nativeElement;
    imageElement.style.transform = `scale(${this.scaleFactor})`;
  }

  onViewZoomedPortion() {
    this.isViewModeActive = !this.isViewModeActive;
  }
  resetZoom() {
    this.scaleFactor = 1;
    this.applyTransform();
    this.imageElement.nativeElement.style.left = '0';
    this.imageElement.nativeElement.style.top = '0';
  }
  toggleAutomaticLineDrawing() {
    this.isAutomaticLineDrawing = !this.isAutomaticLineDrawing;
    if (this.isAutomaticLineDrawing) {
      this.isManualLineDrawing = false; 
    }
  }
  
  
    toggleManualLineDrawing() {
      this.selectedButton2 = '';
      this.isDragAndDropEnabled = false;
      this.resizeButtonActive = false;

      this.isManualLineDrawing = !this.isManualLineDrawing;
      if (!this.isManualLineDrawing) {
        this.currentShape = 'rectangle'; 
        this.isDrawingEnabled = false;
        this.lastSelectedShape = null;
        this.selectedButton=''
      } else {
        this.selectedButton='Scaling'
        this.isAutomaticLineDrawing = false; 
      }
    }

    drawLines() {
      this.lines.forEach((line, index) => {
        const length = this.calculateLength(line.startX, line.startY, line.endX, line.endY);
        this.draw(line.startX, line.startY, line.endX, line.endY, line.color);
        this.drawLength(line.startX, line.startY, line.endX, line.endY, length, line.unit);
        this.drawDot(line.startX, line.startY); // Draw dot at starting point
        this.drawDot(line.endX, line.endY); // Draw dot at ending point

        if (this.lastClickedShapeType === 'line' && this.lastClickedShapeIndex === index) {
          const minX = Math.min(line.startX, line.endX);
          const maxX = Math.max(line.startX, line.endX);
          const minY = Math.min(line.startY, line.endY);
          const maxY = Math.max(line.startY, line.endY);
          
          this.ctx.save();
          this.ctx.strokeStyle = '#007bff';
          this.ctx.lineWidth = 1.5;
          this.ctx.setLineDash([4, 4]);
          this.ctx.strokeRect(minX - 6, minY - 6, (maxX - minX) + 12, (maxY - minY) + 12);
          this.ctx.restore();
        }
      });
    }
  
    draw(startX: number, startY: number, endX: number, endY: number, color: string) {
      this.ctx.beginPath();
      this.ctx.strokeStyle = color; // Set the stroke color
      this.ctx.moveTo(startX, startY);
      this.ctx.lineTo(endX, endY);
      this.ctx.stroke();
      this.ctx.lineWidth=2.5;
      
    }
    selectColor(color: string) {
      this.selectedColor = color;
      
      if (this.lastClickedShapeType === 'dialog' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
          this.dialogs[this.lastClickedShapeIndex].color = color;
      } else if (this.lastClickedShapeType === 'shape' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
          this.shapes[this.lastClickedShapeIndex].color = color;
          this.drawShapes();
          this.drawLines();
      } else if (this.lastClickedShapeType === 'line' && this.lastClickedShapeIndex !== null && this.lastClickedShapeIndex >= 0) {
          this.lines[this.lastClickedShapeIndex].color = color;
          this.drawShapes();
          this.drawLines();
      }

      const editingDialog = this.dialogs.find(d => d.editing);
      if (editingDialog) {
          editingDialog.color = color;
      }
    }
  
    calculateLength(startX: number, startY: number, endX: number, endY: number): number {
      const dx = endX - startX;
      const dy = endY - startY;
      return Math.sqrt(dx * dx + dy * dy);
    }
  
    drawLength(startX: number, startY: number, endX: number, endY: number, length: number, unit: string) {
      const centerX = (startX + endX) / 2;
      const centerY = (startY + endY) / 2;
      const angle = Math.atan2(endY - startY, endX - startX);
      let offsetX = 0;
      let offsetY = 0;
      if (Math.abs(angle) === Math.PI / 2) {
        offsetX = 10; 
        offsetY = 15; 
      } else {
        const slope = (endY - startY) / (endX - startX);
        const lineAngle = Math.atan(slope);
        offsetX = Math.cos(lineAngle) * 20;
        if (angle > Math.PI / 4 && angle < (3 * Math.PI) / 4) {
          offsetY = 20; 
        } else if (angle < -Math.PI / 4 && angle > -(3 * Math.PI) / 4) {
          offsetY = -20; 
        } else {
          offsetY = 15; 
        }
      }
      this.ctx.fillStyle = 'black';
      this.ctx.font = '12px Arial';
      if (Math.abs(angle) === Math.PI / 2) {
        this.ctx.fillText(length.toFixed(2) + ' ' + unit, centerX - 10, centerY + offsetY);
      } else {
        this.ctx.fillText(length.toFixed(2) + ' ' + unit, centerX + offsetX, centerY + offsetY);
      }
    }
    
  
    drawDot(x: number, y: number) {
      this.ctx.beginPath();
      this.ctx.arc(x, y, 5, 0, Math.PI * 2);
      this.ctx.fillStyle = 'black';
      this.ctx.fill();
    }      
    saveState(): void {
      this.history.splice(this.historyIndex + 1);
      this.history.push({
        shapes: JSON.parse(JSON.stringify(this.shapes)),
        lines: JSON.parse(JSON.stringify(this.lines)),
        dialogs: JSON.parse(JSON.stringify(this.dialogs))
      });
      this.historyIndex++;
      this.redoHistory = [];
    }
    
    undo(): void {
      if (this.historyIndex >= 0) {
        const currentState = {
          shapes: JSON.parse(JSON.stringify(this.shapes)),
          lines: JSON.parse(JSON.stringify(this.lines)),
          dialogs: JSON.parse(JSON.stringify(this.dialogs))
        };
        this.redoHistory.push(currentState);
    
        const prevState = this.history[this.historyIndex];
        this.shapes = this.deepCopy(prevState.shapes);
        this.lines = this.deepCopy(prevState.lines);
        this.dialogs = this.deepCopy(prevState.dialogs || []);
        this.clearCanvas();
        this.drawShapes();
        this.drawLines();
        this.historyIndex--;
      } else {
        console.log("No more actions to undo.");
      }
    }
    
    redo(): void {
      if (this.redoHistory.length > 0) {
        const nextState = this.redoHistory.pop();
        const currentState = {
          shapes: JSON.parse(JSON.stringify(this.shapes)),
          lines: JSON.parse(JSON.stringify(this.lines)),
          dialogs: JSON.parse(JSON.stringify(this.dialogs))
        };
        this.history.push(currentState);
    
        this.shapes = this.deepCopy(nextState.shapes);
        this.lines = this.deepCopy(nextState.lines);
        this.dialogs = this.deepCopy(nextState.dialogs || []);
        this.clearCanvas();
        this.drawShapes();
        this.drawLines();
        this.historyIndex++;
      } else {
        console.log("No actions to redo.");
      }
    }
    
    
  deepCopy(obj: any): any {
    if (obj === null || typeof obj !== 'object') return obj;
    const copy: any = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        copy[key] = this.deepCopy(obj[key]);
      }
    }
  
    return copy;
  }  
  takeScreenshot() {
    const targetElement = this.imageWrapper?.nativeElement;
    if (!targetElement) {
      console.error('Image wrapper element not found');
      return Promise.reject('Image wrapper element not found');
    }

    return html2canvas(targetElement, {
      useCORS: true 
    });
  }
  
  takeScreenshotAndDownload() {
    this.takeScreenshot().then(canvas => {
      canvas.toBlob(blob => {
        if (blob) {
          saveAs(blob, 'AnnotatedImage.png');
        } else {
          console.error('Error creating blob');
        }
      });
    }).catch(error => {
      console.error('Error capturing screenshot:', error);
    });
  }
  
  takeScreenshotAndPrint() {
    this.takeScreenshot().then(canvas => {
      const image = canvas.toDataURL('image/png');
      const printWin = window.open('', '', 'width=650,height=800');
      if (printWin) {
        printWin.document.write('<html><head><title>Print Image</title></head><body></body></html>');
        printWin.document.close();
        
        const img = printWin.document.createElement('img');
        img.onload = () => {
          printWin.focus();
          printWin.print();
          printWin.close();
        };
        img.src = image;
        printWin.document.body.appendChild(img);
      } else {
        console.error('Error opening print window');
      }
    }).catch(error => {
      console.error('Error capturing screenshot for print:', error);
    });
  }
  onSvgClick() {
    this.selectedButton2 = '';
    this.isDragAndDropEnabled = false;
    this.resizeButtonActive = false;

    if (this.selectedButton === 'Text') {
      this.selectedButton = '';
    } else {
      this.selectedButton = 'Text';
      this.isDrawingEnabled = false;
    }
  }
  startResizeDialog(event: MouseEvent, dialog: Dialog) {
    this.resizeDialog = dialog;
    this.startX = event.clientX;
    this.startY = event.clientY;
    this.startWidth = dialog.width;
    this.startHeight = dialog.height;
    event.stopPropagation();

    window.addEventListener('mousemove', this.onResizeDialog);
    window.addEventListener('mouseup', this.stopResizeDialog);
  }

  onResizeDialog = (event: MouseEvent) => {
    if (this.resizeDialog) {
      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;

      this.resizeDialog.width = Math.max(this.getTextWidth(this.resizeDialog.text, '16px Arial') + 20, this.startWidth + deltaX);
      this.resizeDialog.height = Math.max(10, this.startHeight + deltaY);
    }
  };

  stopResizeDialog = () => {
    if (this.resizeDialog) {
      this.saveState();
    }
    this.resizeDialog = null;
    window.removeEventListener('mousemove', this.onResizeDialog);
    window.removeEventListener('mouseup', this.stopResizeDialog);
  };

  toggleHoverState(index: number, isHovered: boolean, isSquare: boolean) {
    if (isSquare) {
      this.isSquareHovered[index] = isHovered;
    } else {
      this.isDialogueHovered[index] = isHovered;
    }
  }
  toggleDialogHoverState(index: number, isHovered: boolean) {
    if (this.dialogs[index]) {
      this.dialogs[index].hovered = isHovered;
    }
  }

  deleteDialog(index: number){
    this.saveState();
    this.dialogs.splice(index,1);
    this.isDialogueHovered.splice(index,1);
  }

  selectDialog(index: number){
    this.lastClickedShapeType = 'dialog';
    this.lastClickedShapeIndex = index;
  }

  editDialog(dialog: Dialog) {
    dialog.editing = true;
    const dialogIndex = this.dialogs.indexOf(dialog);
    if (dialogIndex !== -1) {
      this.selectDialog(dialogIndex);
    }
    setTimeout(() => {
      if (dialogIndex !== -1) {
        const dialogElements = this.elementRef.nativeElement.querySelectorAll('.dialogue-box');
        if (dialogElements[dialogIndex]) {
          const input = dialogElements[dialogIndex].querySelector('.inputBox') as HTMLInputElement;
          if (input) {
            input.focus();
          }
        }
      }
    }, 50);
  }

  saveDialog(dialog: Dialog) {
    dialog.editing = false;
    if (!dialog.text || dialog.text.trim() === '') {
      const index = this.dialogs.indexOf(dialog);
      if (index !== -1) {
        this.deleteDialog(index);
      }
    } else {
      this.saveState();
      this.updateDialogWidth(dialog);
    }
  }

  updateDialogWidth(dialog: Dialog) {
    const maxWidth = 350; // Max width constraint for the dialogue box
    const textVal = dialog.text || '';
    const textWidth = this.getTextWidth(textVal, '16px Arial');
    const newDialogWidth = Math.max(80, Math.min(textWidth, maxWidth) + 33); // Ensure minimum width of 80
    dialog.width = newDialogWidth;
    const lineHeight = 24; // standard line height
    const lines = Math.max(1, Math.ceil(textWidth / (newDialogWidth - 33))); 
    const dialogHeight = lines * lineHeight + 10; // add some padding
    dialog.height = dialogHeight;
  }

  onTextChange(dialog: Dialog, index: number) {
    this.updateDialogWidth(dialog);
  }

  onKeydown(event: KeyboardEvent, dialog: Dialog, index: number) {
    if (event.key === 'Backspace' && (!dialog.text || dialog.text.length === 0)) {
      event.preventDefault();
      this.deleteDialog(index);
    }
  }

  

  startDragDialog(event: MouseEvent, dialog: Dialog) {
    this.draggingElement = event.currentTarget as HTMLElement;
    this.startX = event.clientX - dialog.left;
    this.startY = event.clientY - dialog.top;
    event.stopPropagation();

    window.addEventListener('mousemove', this.onDragDialog);
    window.addEventListener('mouseup', this.stopDragDialog);
}


onDragDialog = (event: MouseEvent) => {
  if (this.draggingElement) {
    const offsetX = event.clientX - this.startX;
    const offsetY = event.clientY - this.startY;
    this.draggingElement.style.left = `${offsetX}px`;
    this.draggingElement.style.top = `${offsetY}px`;

    // Update dialog position
    const index = this.dialogs.findIndex(dialog => dialog.editing);
    if (index !== -1) {
      this.dialogs[index].left = offsetX;
      this.dialogs[index].top = offsetY;
    }
  }
};

stopDragDialog = () => {
  if (this.draggingElement) {
    this.saveState();
  }
  this.draggingElement = null;
  window.removeEventListener('mousemove', this.onDragDialog);
  window.removeEventListener('mouseup', this.stopDragDialog);
};
  
  //width portion for the text box
  getTextWidth(text: string, font: string): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = font;
      const metrics = context.measureText(text);
      return metrics.width;
    }
    return 0;
}
  //height portion for text box 
  getTextHeight(text: string, width: number, font: string): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = font;
      const words = text.split(' ');
      let line = '';
      let lines = 0;
      for (let n = 0; n < words.length; n++) {
        const testLine = line + words[n] + ' ';
        const metrics = context.measureText(testLine);
        const testWidth = metrics.width;
        if (testWidth > width && n > 0) {
          lines++;
          line = words[n] + ' ';
        } else {
          line = testLine;
        }
      }
      lines++;
      return lines * parseInt(font, 10); 
    }
    return 0;
  }
  }
            
